import { isEmpty } from 'lodash';

export default (products, status) => !isEmpty(products) && products.map((s) => {
  const productToUpdate = {
    id: s.id,
    visibilityStatus: status,
  };
  return productToUpdate;
});
